export const FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_FAILURE_DK = 'FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_FAILURE_DK';
export const FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_REQUEST_DK = 'FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_REQUEST_DK';
export const FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_SUCCESS_DK = 'FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_SUCCESS_DK';

export const CREATE_BILL_ENTRIES_REQUEST_DK = 'CREATE_BILL_ENTRIES_REQUEST_DK';
export const CREATE_BILL_ENTRIES_SUCCESS_DK = 'CREATE_BILL_ENTRIES_SUCCESS_DK';
export const CREATE_BILL_ENTRIES_FAILURE_DK = 'CREATE_BILL_ENTRIES_FAILURE_DK';

export const CREATE_USER_FORM_BILL_ENTRIES_DK = 'CREATE_USER_FORM_BILL_ENTRIES_DK';

export const CREATE_USER_FORM_BILL_ENTRY_EDIT_QTY_DK = 'CREATE_USER_FORM_BILL_ENTRY_EDIT_QTY_DK';

export const SET_EDIT_QUANTITY_GRID_DATA_BILL_ENTRIES_ID = 'SET_EDIT_QUANTITY_GRID_DATA_BILL_ENTRIES_ID';

// NEW BILL MODULATION //

export const CREATE_ADD_BILL_ENTRIES_REQUEST_DK = 'CREATE_ADD_BILL_ENTRIES_REQUEST_DK';
export const CREATE_ADD_BILL_ENTRIES_SUCCESS_DK = 'CREATE_ADD_BILL_ENTRIES_SUCCESS_DK';
export const CREATE_ADD_BILL_ENTRIES_FAILURE_DK = 'CREATE_ADD_BILL_ENTRIES_FAILURE_DK';

export const CREATE_ADD_BILL_ENTRIES_DETAILS_REQUEST_DK = 'CREATE_ADD_BILL_ENTRIES_DETAILS_REQUEST_DK';
export const CREATE_ADD_BILL_ENTRIES_DETAILS_SUCCESS_DK = 'CREATE_ADD_BILL_ENTRIES_DETAILS_SUCCESS_DK';
export const CREATE_ADD_BILL_ENTRIES_DETAILS_FAILURE_DK = 'CREATE_ADD_BILL_ENTRIES_DETAILS_FAILURE_DK';

// VERIFY BILL ENTRY //
export const FETCH_VERIFY_BILL_ENTRIES_REQUEST_DK = 'FETCH_VERIFY_BILL_ENTRIES_REQUEST_DK';
export const FETCH_VERIFY_BILL_ENTRIES_SUCCESS_DK = 'FETCH_VERIFY_BILL_ENTRIES_SUCCESS_DK';
export const FETCH_VERIFY_BILL_ENTRIES_FAILURE_DK = 'FETCH_VERIFY_BILL_ENTRIES_FAILURE_DK';

export const FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_REQUEST_DK = 'FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_REQUEST_DK';
export const FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_SUCCESS_DK = 'FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_SUCCESS_DK';
export const FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_FAILURE_DK = 'FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_FAILURE_DK';

// VERIFY BILL ENTRY //
export const FETCH_VERIFY_BILL_ENTRIES_FORM_REQUEST_DK = 'FETCH_VERIFY_BILL_ENTRIES_FORM_REQUEST_DK';
export const FETCH_VERIFY_BILL_ENTRIES_FORM_SUCCESS_DK = 'FETCH_VERIFY_BILL_ENTRIES_FORM_SUCCESS_DK';
export const FETCH_VERIFY_BILL_ENTRIES_FORM_FAILURE_DK = 'FETCH_VERIFY_BILL_ENTRIES_FORM_FAILURE_DK';


// VERIFY BILL ENTRY //
export const FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_REQUEST_DK = 'FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_REQUEST_DK';
export const FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_SUCCESS_DK = 'FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_SUCCESS_DK';
export const FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_FAILURE_DK = 'FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_FAILURE_DK';

export const UPDATE_VERIFY_BILL_ENTRY_DETAILS_REQUEST_DK = 'UPDATE_VERIFY_BILL_ENTRY_DETAILS_REQUEST_DK';
export const UPDATE_VERIFY_BILL_ENTRY_DETAILS_SUCCESS_DK = 'UPDATE_VERIFY_BILL_ENTRY_DETAILS_SUCCESS_DK';
export const UPDATE_VERIFY_BILL_ENTRY_DETAILS_FAILURE_DK = 'UPDATE_VERIFY_BILL_ENTRY_DETAILS_FAILURE_DK';

export const UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_REQUEST_DK = 'UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_REQUEST_DK';
export const UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_SUCCESS_DK = 'UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_SUCCESS_DK';
export const UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_FAILURE_DK = 'UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_FAILURE_DK';

export const NAVIGATE_VERIFY_BILL_ENTRY_DETAIL = 'NAVIGATE_VERIFY_BILL_ENTRY_DETAIL';

export const CREATE_USER_FORM_VERIFY_BILL_ENTRIES_DK = 'CREATE_USER_FORM_VERIFY_BILL_ENTRIES_DK';

export const VERIFY_BILL_ENTRY_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'VERIFY_BILL_ENTRY_USERFORM_NAVIGATE_TO_DETAIL_TAB';

export const VERIFY_BILL_ENTRY_USERFORM_RESET = 'VERIFY_BILL_ENTRY_USERFORM_RESET';

export const NAVIGATE_BILL_ENTRIES = 'NAVIGATE_BILL_ENTRIES';


export const CREATE_BILL_ENTRY_APPROVAL_OTP_REQUEST = 'CREATE_BILL_ENTRY_APPROVAL_OTP_REQUEST';
export const CREATE_BILL_ENTRY_APPROVAL_OTP_SUCCESS = 'CREATE_BILL_ENTRY_APPROVAL_OTP_SUCCESS';
export const CREATE_BILL_ENTRY_APPROVAL_OTP_FAILURE = 'CREATE_BILL_ENTRY_APPROVAL_OTP_FAILURE';

export const UPDATE_BILL_ENTRY_DELETE_REQUEST = 'UPDATE_BILL_ENTRY_DELETE_REQUEST';
export const UPDATE_BILL_ENTRY_DELETE_SUCCESS = 'UPDATE_BILL_ENTRY_DELETE_SUCCESS';
export const UPDATE_BILL_ENTRY_DELETE_FAILURE = 'UPDATE_BILL_ENTRY_DELETE_FAILURE';

export const CREATE_BILL_ENTRY_WITH_DEBIT_OR_CREDIT_NOTE_REQUEST = 'CREATE_BILL_ENTRY_WITH_DEBIT_OR_CREDIT_NOTE_REQUEST';
export const CREATE_BILL_ENTRY_WITH_DEBIT_OR_CREDIT_NOTE_SUCCESS = 'CREATE_BILL_ENTRY_WITH_DEBIT_OR_CREDIT_NOTE_SUCCESS';
export const CREATE_BILL_ENTRY_WITH_DEBIT_OR_CREDIT_NOTE_FAILURE = 'CREATE_BILL_ENTRY_WITH_DEBIT_OR_CREDIT_NOTE_FAILURE';

export const FETCH_TALLY_FORMAT_DATA_REQUEST_DK = 'FETCH_TALLY_FORMAT_DATA_REQUEST_DK';
export const FETCH_TALLY_FORMAT_DATA_SUCCESS_DK = 'FETCH_TALLY_FORMAT_DATA_SUCCESS_DK';
export const FETCH_TALLY_FORMAT_DATA_FAILURE_DK = 'FETCH_TALLY_FORMAT_DATA_FAILURE_DK';

export const CREATE_BILL_ENTRY_DEBIT_DETAIL_REQUEST = 'CREATE_BILL_ENTRY_DEBIT_DETAIL_REQUEST';
export const CREATE_BILL_ENTRY_DEBIT_DETAIL_SUCCESS = 'CREATE_BILL_ENTRY_DEBIT_DETAIL_SUCCES';
export const CREATE_BILL_ENTRY_DEBIT_DETAIL_FAILURE = 'CREATE_BILL_ENTRY_DEBIT_DETAIL_FAILURE';

export const FETCH_BILL_ENTRY_BRL_NUMBER_REQUEST = 'FETCH_BILL_ENTRY_BRL_NUMBER_REQUEST';
export const FETCH_BILL_ENTRY_BRL_NUMBER_SUCCESS = 'FETCH_BILL_ENTRY_BRL_NUMBER_SUCCESS';
export const FETCH_BILL_ENTRY_BRL_NUMBER_FAILURE = 'FETCH_BILL_ENTRY_BRL_NUMBER_FAILURE';

//Debit-Memo---------------------------------------------------------------------------------
export const FETCH_DEBIT_MEMO_DATA_REQUEST = 'FETCH_DEBIT_MEMO_DATA_REQUEST';
export const FETCH_DEBIT_MEMO_DATA_SUCCESS = 'FETCH_DEBIT_MEMO_DATA_SUCCESS';
export const FETCH_DEBIT_MEMO_DATA_FAILURE = 'FETCH_DEBIT_MEMO_DATA_FAILURE';

export const CREATE_DEBIT_MEMO_DETAIL_REQUEST = 'CREATE_DEBIT_MEMO_DETAIL_REQUEST';
export const CREATE_DEBIT_MEMO_DETAIL_SUCCESS = 'CREATE_DEBIT_MEMO_DETAIL_SUCCESS';
export const CREATE_DEBIT_MEMO_DETAIL_FAILURE = 'CREATE_DEBIT_MEMO_DETAIL_FAILURE';

export const FETCH_DEBIT_MEMO_QTY_REQUEST = 'FETCH_DEBIT_MEMO_QTY_REQUEST';
export const FETCH_DEBIT_MEMO_QTY_SUCCESS = 'FETCH_DEBIT_MEMO_QTY_SUCCESS';
export const FETCH_DEBIT_MEMO_QTY_FAILURE = 'FETCH_DEBIT_MEMO_QTY_FAILURE';

export const FETCH_DEBIT_MEMO_REPORT_REQUEST = 'FETCH_DEBIT_MEMO_REPORT_REQUEST';
export const FETCH_DEBIT_MEMO_REPORT_SUCCESS = 'FETCH_DEBIT_MEMO_REPORT_SUCCESS';
export const FETCH_DEBIT_MEMO_REPORT_FAILURE = 'FETCH_DEBIT_MEMO_REPORT_FAILURE';

export const FETCH_DEBIT_MEMO_INVOICE_REQUEST = 'FETCH_DEBIT_MEMO_INVOICE_REQUEST';
export const FETCH_DEBIT_MEMO_INVOICE_SUCCESS = 'FETCH_DEBIT_MEMO_INVOICE_SUCCESS';
export const FETCH_DEBIT_MEMO_INVOICE_FAILURE = 'FETCH_DEBIT_MEMO_INVOICE_FAILURE';

export const SET_TABLE_EDIT_OF_DEBIT_MEMO_DATA = 'SET_TABLE_EDIT_OF_DEBIT_MEMO_DATA';

export const CREATE_USER_FORM_DEBIT_MEMO_ENTRIES = 'CREATE_USER_FORM_DEBIT_MEMO_ENTRIES';

export const DEBIT_MEMO_USERFORM_RESET = 'DEBIT_MEMO_USERFORM_RESET';

export const DELETE_DEBIT_MRMO_REPORTS_REQUEST = 'DELETE_DEBIT_MRMO_REPORTS_REQUEST';
export const DELETE_DEBIT_MRMO_REPORTS_SUCCESS = 'DELETE_DEBIT_MRMO_REPORTS_SUCCESS';
export const DELETE_DEBIT_MRMO_REPORTS_FAILURE = 'DELETE_DEBIT_MRMO_REPORTS_FAILURE';

export const FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_NOTIFY_REQUEST = 'FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_NOTIFY_REQUEST';
export const FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_NOTIFY_SUCCESS = 'FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_NOTIFY_SUCCESS';
export const FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_NOTIFY_FAILURE = 'FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_NOTIFY_FAILURE';
